// src/ScrollToTop/ScrollToTop.tsx
import { useEffect } from "react";
import { useNavigationType } from "react-router-dom";
var ScrollToTop = ({ forceScroll = false }) => {
  const navigationType = useNavigationType();
  useEffect(() => {
    if (forceScroll || navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [navigationType, forceScroll]);
  return null;
};
export {
  ScrollToTop
};
//# sourceMappingURL=index.js.map
